export default "__VITE_ASSET__d5a5764a__"